// src/hooks/useIsMobile.js
import { useState, useEffect } from "react";

/**
 * Хук «является ли текущее окно мобильным» (меньше или равно maxWidth).
 * По умолчанию maxWidth = 640px, но его можно переопределить при вызове.
 */
export function useIsMobile(maxWidth = 640) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= maxWidth);
  const [vhPx, setVhPx] = useState(window.innerHeight);

  useEffect(() => {
    const media = window.matchMedia(`(max-width:${maxWidth}px)`);
    const listener = (e) => setIsMobile(e.matches);

    media.addEventListener("change", listener);
    setIsMobile(media.matches);

    const onResize = () => setVhPx(window.innerHeight);
    window.addEventListener("resize", onResize, { passive: true });
    onResize();

    return () => {
      media.removeEventListener("change", listener);
      window.removeEventListener("resize", onResize);
    };
  }, [maxWidth]);

  return { isMobile, vhPx };
}